import axios from 'axios';

export {
  downloadOrders,
  placeOrderV2,
  updateOrderStatus,
  updateOrder,
  updateOrderNumbers,
  getPaginatedOrders,
  getOrderStatistics,
  splitOrderItem,
  cancelLineItems,
};

function downloadOrders(payload, orderIds) {
  return axios.post("/api/downloadOrders", { ...payload, orderIds }, { responseType: "blob" });
}

async function getOrderStatistics(payload = {}) {
  try {
    const { data } = await axios.get("/api/getOrderStatistics", { params: payload });
    // const { statistics } = data.payload.data;
    return data;
  } catch (ex) {
    console.dir(ex);
    return {};
  }
}

async function getPaginatedOrders(payload = { query_type: "ALL", page: 1, limit: 100 }) {
  try {
    const { data } = await axios.post("/api/getPaginatedOrders",  payload);
    const { metadata, orders } = data;
    return { metadata, orders };
  } catch (ex) {
    // eslint-disable-next-line no-console
    console.error("getPaginatedOrders failed", ex);
    return { metadata: { total: 0, page: 0, limit: 0 }, orders: [] };
  }
}

function placeOrderV2(payload) {
  return axios.post("/api/placeOrderV2", payload);
}

function updateOrderStatus(orderId, { status, orderCancelled, feedback }) {
  return axios.put(`/api/orders/updateStatus/${orderId}`, { params: { status, orderCancelled, feedback } });
}

function updateOrderNumbers(orderId, { offers }) {
  return axios.put(`/api/orders/updateOrderNumbers/${orderId}`, { params: { offers } });
}

function updateOrder(orderId, order, feedback) {
  return axios.put(`/api/orders/${orderId}`, { params: { order, feedback } });
}

async function splitOrderItem(splitOffer) {
  return axios.post(`/api/splitOrderItem`, splitOffer);
}

async function cancelLineItems(orderId, lineItems) {
  const offersDto = lineItems.map((o) => {
    return { _id: o._id, lineItemCancelled: o.lineItemCancelled };
  });
  return axios.put(`/api/order/${orderId}/line-items/cancel`, { offers: offersDto });
}